<template>
    <ion-grid>
        <ion-row>

            <!--<editor-fold desc="skeleton">-->

            <ion-col v-if="loading">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            <ion-skeleton-text animated style="height: 30px; width: 65%;"/>
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <ion-skeleton-text animated style="height: 20px;"/>
                        <ion-skeleton-text animated style="height: 20px;"/>
                    </ion-card-content>
                </ion-card>
            </ion-col>

            <ion-col v-else-if="error" class="error apollo">
                <ion-text>{{ $t('ncrypt.something_went_wrong') }}</ion-text>
            </ion-col>

            <!--</editor-fold>-->

            <ion-col
                v-else-if="helpItems.length"
                v-show="typeof not === 'undefined' || parseInt(helpItem.id) !== not"
                v-for="helpItem in helpItems" :key="helpItem.id"
                size="12" size-xl="4" size-lg="6"
                style="display: flex; align-items: stretch;"
            >
                <ion-card style="display: flex; flex-direction: column; flex: 1;">
                    <ion-card-header>
                        <ion-card-title>{{ helpItem.title }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content style="display: flex; align-items: stretch; flex-direction: column; flex: 1;">
                        <ion-item lines="none" class="ion-no-padding" style="flex: 1;">
                            <ion-text>{{ helpItem.summary }}</ion-text>
                        </ion-item>
                        <ion-button fill="clear" @click="openHelpItem(helpItem.id)" style="margin-top: 10px;">
                            {{ $t('ncrypt.read_more') }}
                        </ion-button>
                    </ion-card-content>
                </ion-card>
            </ion-col>

            <ion-col v-else class="no-result apollo">
                <ion-text>{{ $t('ncrypt.not_found_plural') }}</ion-text>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
    import gql from "graphql-tag";
    import {EventBus} from "@/event-bus";

    export default {
        name: "HelpItems",
        props: {
            not: {type: Number},
        },
        methods: {
            async close() {
                await this.$ionic.menuController.close('end');
            },
            async openHelpItem(id) {
                await this.close();

                await this.$router.push({name: 'help-item', params: {id}})
            },
        },
        data() {
            return {
                loading: 0,
                error: null,
                helpItems: [],
            };
        },
        mounted() {
            EventBus.$on('localeSwitched', locale => {
                this.$apollo.queries.helpItems.refetch();
            });
        },
        apollo: {
            $query: {
                loadingKey: 'loading',
            },
            helpItems: {
                query: gql`query {
                      helpItems(
                        orderBy: [{field: "sort", order: DESC}]
                      ) {
                        id
                        title
                        summary
                    }
                }`,
                variables() {
                    return {};
                },
                error(error) {
                    window.console.error(`We've got an error!`, error);
                    this.error = error;
                },
            },
        },
    }
</script>
